export interface NavigationMenuItem {
  label: string;
  path?: string | null;
  type?: string;
  children?: NavigationMenuItem[];
}

// Keep the menu's display order and skip section headings without destinations.
export const getSubmenuDestinations = (items: NavigationMenuItem[] = []) => {
  const destinations: { label: string; path: string }[] = [];
  const seen = new Set<string>();
  const visit = (entries: NavigationMenuItem[]) => {
    for (const item of entries) {
      if (item.type !== 'title' && item.path && !seen.has(item.path)) {
        destinations.push({ label: item.label, path: item.path });
        seen.add(item.path);
      }
      visit(item.children || []);
    }
  };
  visit(items);
  return destinations;
};
